
import { categoriesColors, VALID_EXTENSIONS } from '../_constants/constants'
export default {
  data () {
    return {
      selectedCategory: '',
      selectedSubCategory: '',
      internalCategoryId: 0
    }
  },
  methods: {
    getSelectedCategoryObject (categoryId, subcategoryId) {
      if (subcategoryId) {
        let subcategory = this.categoryList.find(
          c => c.subcategoryId === subcategoryId
        )
        return subcategory || null
      } else {
        let category = this.categoryList.find(
          c => c.categoryId === categoryId
        )
        return category || null
      }
    },
    setSelectedCategoryObjectData () {
      this._setSelectedCategoryObjectStyle()
      this._setSelectedCategoryIcon()
    },
    _setSelectedCategoryObjectStyle () {
      if (!this.selectedCategoryObject) return
      let categoryStyleData = this.categories.find(
        el =>
          el.id === this.selectedCategoryObject.categoryId)
      if (
        this.selectedCategoryObject &&
        this.selectedCategoryObject.categoryId
      ) {
        if (categoryStyleData) {
          this.selectedCategoryObject.style = { color: categoryStyleData.color }
          this.selectedCategoryObject.imageUrl = categoryStyleData.imageUrl
          this.selectedCategoryObject.headerImageUrl = categoryStyleData.headerImageUrl
        }
      }
      if (
        this.selectedCategoryObject &&
        this.selectedCategoryObject.subcategoryId
      ) {
        this.selectedCategoryObject.style = { color: '#162743' }
      }
    },
    _setSelectedCategoryIcon () {
      if (!this.selectedCategoryObject) return
      if (this.selectedCategoryObject.categoryId && !this.selectedCategoryObject.subcategoryId) {
        const icon = categoriesColors.find(el => el.categoryName === this.selectedCategoryObject.name)
        if (icon) {
          this.selectedCategoryObject.icon = icon.icon
        }
      }
    }
  },
  computed: {
    categories () {
      return this.$store.getters['CategoriesStore/categories'] || []
    },
    defaultCategoriesOffice () {
      return this.$store.getters['CategoriesStore/defaultCategoriesOffice'] || []
    },
    customCategories () {
      return this.$store.getters['CategoriesStore/customCategories'] || []
    },
    validExtensions () {
      return VALID_EXTENSIONS
    }
  }
}
